import type { ReactElement } from 'react';
import { motion } from 'framer-motion';
import type { Transition } from 'framer-motion';
import { Ccontainerskeleton } from '../Ccontainerskeleton';
interface CimageSkeletonProps {
    radiusValue?: number;
    transition: Transition;
}
export function CimageSkeleton({ radiusValue, transition, }: CimageSkeletonProps): ReactElement {
    return (
    <motion.span key="skeleton" initial={{ opacity: 1 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={transition} style={{
            position: 'absolute',
            inset: 0,
            zIndex: 1,
            pointerEvents: 'none',
        }}>
      <Ccontainerskeleton dataElScope="Cimage/CimageSkeleton" width="100%" height="100%" radius={radiusValue}/>
    </motion.span>
    );
}
